export default {
  namespaced: true,
  state: {
    modalContent: [],
    openOnboarding: false,
    openOnboardingWizard: false,
    openPremiumCongrats: false,
    onboardingCookieName: ''
  },
  getters: {
    isOnboardingOpen: state => state.openOnboarding,
    isOnboardingWizardOpen: state => state.openOnboardingWizard,
    isPremiumCongratsOpen: state => state.openPremiumCongrats,
    getModalContent: state => state.modalContent.slides,
    getModalForce: state => (state.modalContent.forceOpen) ? state.modalContent.forceOpen : false,
    getModalTrigger: state => (state.modalContent.hasTrigger) ? state.modalContent.hasTrigger : false,
    getOnboardingCookieName: state => state.onboardingCookieName
  },
  mutations: {
    SET_MODAL_CONTENT (state, modalContent) {
      state.modalContent = modalContent
    },
    OPEN_ONBOARDING (state) {
      state.openOnboarding = true
    },
    CLOSE_ONBOARDING (state) {
      state.openOnboarding = false
    },
    SET_ONBOARDING_COOKIENAME (state, name) {
      state.onboardingCookieName = name
    },
    SET_ONBOARDING_COOKIE (state, value) {
      var d1 = new Date (), expire = new Date ( d1 );
      // expire.setMinutes ( d1.getMinutes() + 60 * 12 );
      expire.setDate(d1.getDate() + 400); // 400 days max-age https://chromestatus.com/feature/4887741241229312
      this.getters.getRoot.$cookies.set(state.onboardingCookieName, value, expire, '/');
    },
    OPEN_ONBOARDING_WIZARD (state) {
      state.openOnboardingWizard = true
    },
    CLOSE_ONBOARDING_WIZARD (state) {
      state.openOnboardingWizard = false
    },
    OPEN_PREMIUM_CONGRATS (state) {
      state.openPremiumCongrats = true
    },
    CLOSE_PREMIUM_CONGRATS (state) {
      state.openPremiumCongrats = false
    }
  },
  actions: {
    checkOnboarding ({ getters, commit, rootGetters }, cookieName) {
      commit('SET_ONBOARDING_COOKIENAME', cookieName);

      const onboardingCookie = this.getters.getRoot.$cookies.get(getters.getOnboardingCookieName)
      if (onboardingCookie === null) {
        commit('SET_ONBOARDING_COOKIE', true);
        commit('OPEN_ONBOARDING');
      } else {
        if (onboardingCookie === 'true' || (getters.getModalForce 
                                        && ((rootGetters['getIsPremium'] && getters.getModalForce === 'premium') 
                                        || (!rootGetters['getIsPremium'] && getters.getModalForce === 'basic')))) {
          commit('OPEN_ONBOARDING');
        } else {
          commit('CLOSE_ONBOARDING');
        }
      }
    },
    openOnboarding ({ commit }) {
      commit('OPEN_ONBOARDING');
    },
    dismissOnboarding ({ commit }) {
      commit('SET_ONBOARDING_COOKIE', false);
      commit('CLOSE_ONBOARDING');
    },
    closeOnboarding ({ commit }) {
      commit('CLOSE_ONBOARDING');
    }
  }
}
